import { create } from 'zustand';

interface User {
  id: string;
  email: string;
  role: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
}

// localStorage에서 초기 상태 로드
const loadAuthFromStorage = (): { user: User | null; token: string | null } => {
  if (typeof window === 'undefined') {
    return { user: null, token: null };
  }
  
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  // 유효성 검사: null, undefined, 빈 문자열, "undefined" 문자열 체크
  if (!userStr || userStr === 'null' || userStr === 'undefined' || userStr.trim() === '') {
    return { user: null, token };
  }
  
  try {
    const user = JSON.parse(userStr);
    return { user, token };
  } catch (error) {
    console.error('Failed to parse user from localStorage:', error);
    // 잘못된 데이터는 삭제
    localStorage.removeItem('user');
    return { user: null, token };
  }
};

const { user: initialUser, token: initialToken } = loadAuthFromStorage();

export const useAuthStore = create<AuthState>((set) => ({
  user: initialUser,
  token: initialToken,
  isAuthenticated: !!initialToken && !!initialUser,
  setAuth: (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
  },
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null, isAuthenticated: false });
  },
}));

